import ProductList from "../../components/product/list";
import useAppNavigate from "../../components/router/use-app-navigate";
import ShopLayout from "../../components/signup/shop-layout";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

interface IShopPurchase {
  type?: number;
  number?: string;
  shippingId?: number;
  modemId?: number;
  tags?: string;
}

interface LocationState {
  ngnNumber?: string;
  selectedType?: number;
  tags: string;
}

export default function ShopPurchase({
  type,
  number,
  shippingId,
}: IShopPurchase) {
  const navigate = useAppNavigate();
  const location = useLocation();
  const state = location.state as LocationState | null;

  const ngnNumber = useMemo(() => state?.ngnNumber ?? number, [state, number]);
  console.log("ngnNumber", ngnNumber);
  const selectedType = useMemo(() => state?.selectedType ?? type, [
    state,
    type,
  ]);

  if (!selectedType) {
    console.warn("No valid `type` or `selectedType` found.");
    return null;
  }

  return (
    <ShopLayout
      step={ngnNumber != null ? 2 : 1}
      type={selectedType}
      steps={[1, 2, 3]}
    >
      <ProductList
        type={selectedType}
        isShop={true}
        ngnNumber={ngnNumber}
        shippingId={shippingId}
        tags={state?.tags!}
        onSuccess={() => navigate(`/shop/cellPhone/${selectedType}`)}
      />
    </ShopLayout>
  );
}
